import {Injectable, Inject} from 'ng-metadata/core';
import {getInstitutionCode} from '../../appConfig/appConfigForward';


const orderBy= require('lodash/orderBy');

interface InstitutionValue {
    institutionCode:string;
    patronId:string;
}

interface Institution {
    hasActivity: boolean;
    label:string;
    value:InstitutionValue;
    isClicked: boolean;
}

@Injectable()
export class LinkedUserSelectorService {

    private _institutionsList: Institution[];
    private _institutionsWithActivities: Institution[];
    private _selectedInstitution: InstitutionValue;

    constructor() {
    }

     public setInstitutionsList(response){
        if(this._institutionsList){
            return;
        }
        try{
            let accountList= response.data.accountslist.account;
            this._institutionsList= orderBy(accountList.map((account)=>{return {label:(account.primoinstitution ? account.primoinstitution : account.institutioncode), isClicked : false, hasActivity: account.hasactivity ? account.hasactivity : false, value:{institutionCode:account.institutioncode, patronId: account.useridentifier}}}),(account)=>account.value.institutionCode, 'asc');
            this._institutionsWithActivities= this._institutionsList.filter((inst)=> inst.hasActivity);
        }
        catch(err){
        }
        this.setInitialInstitution();
    }

    private setInitialInstitution(){
        let loginInstCode= getInstitutionCode();
        this._selectedInstitution= this._institutionsList.filter((inst)=>inst.label===loginInstCode)[0].value;
    }

    get institutionsList(){
        return this._institutionsList;
    }

    get institutionsWithActivitiesList(){
        return this._institutionsWithActivities;
    }

    get selectedInstitution(){
        return this._selectedInstitution;
    }

    set selectedInstitution(inst){
        this._selectedInstitution= inst;
    }


}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/account/linkedUserSelector/linkedUserSelector.service.ts